(() => {
  if (!window.customElements || customElements.get('ayeior-purchase-controls')) return;
  class AyeiorPurchaseControls extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._owned = [];
      this._signature = '';
      this._load = event => {
        if (event?.type === 'shopify:section:load' && !event.target.contains(this) && !event.target.querySelector('maison-product-page')) return;
        if (this.isConnected) this.mount();
      };
      this._change = () => this.updateBadge();
      this._select = event => {
        const block = this._owned.find(node => node.dataset.ayeiorControlBlock === String(event.detail?.blockId));
        if (block) block.scrollIntoView({ block: 'center', behavior: 'auto' });
      };
      document.addEventListener('shopify:section:load', this._load);
      document.addEventListener('shopify:block:select', this._select);
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this._load, { once: true });
      else queueMicrotask(() => this._load());
    }
    disconnectedCallback() {
      this._connected = false;
      document.removeEventListener('DOMContentLoaded', this._load);
      document.removeEventListener('shopify:section:load', this._load);
      document.removeEventListener('shopify:block:select', this._select);
      this.releaseRoot(); this.removePanels(); this._signature = '';
    }
    removePanels() { (this._owned || []).forEach(node => node.remove()); this._owned = []; }
    releaseRoot() {
      if (!this._root) return;
      this._root.removeEventListener('change', this._change);
      this._root.classList.remove('ayeior-has-purchase-controls');
      const badge = this._root.querySelector('[data-maison-sale-badge]');
      if (badge && this._originalBadge !== undefined) badge.textContent = this._originalBadge;
      const fieldset = this._root.querySelector('.maison-pdp__variants.ayeior-single-colour');
      if (fieldset) {
        fieldset.classList.remove('ayeior-single-colour');
        const legend = fieldset.querySelector('legend');
        if (legend && this._originalLegend !== undefined) legend.textContent = this._originalLegend;
      }
      this._root = null; this._originalBadge = undefined; this._originalLegend = undefined;
    }
    mount() {
      const configNode = this.querySelector('[data-ayeior-controls-config]');
      if (!configNode) return;
      try { this._config = JSON.parse(configNode.textContent); } catch (_) { return; }
      if (!['10604221300929', '11044564730049'].includes(String(this._config.productId))) return;
      const root = document.querySelector('maison-product-page');
      if (!root) return;
      const templates = [...this.querySelectorAll('template[data-ayeior-panel]')];
      const signature = configNode.textContent + templates.map(node => node.dataset.ayeiorPanel + node.innerHTML).join('');
      if (root === this._root && signature === this._signature && this._owned.every(node => node.isConnected && root.contains(node))) { this.updateBadge(); return; }
      if (root !== this._root) {
        this.releaseRoot(); this._root = root;
        root.classList.add('ayeior-has-purchase-controls');
        this._originalBadge = root.querySelector('[data-maison-sale-badge]')?.textContent;
        this._originalLegend = root.querySelector('.maison-pdp__variants legend')?.textContent;
        root.addEventListener('change', this._change);
      }
      this.removePanels();
      for (const template of templates) {
        const panel = template.content.firstElementChild?.cloneNode(true);
        if (!panel || !panel.querySelector('[data-ayeior-benefit]')) continue;
        if (template.dataset.ayeiorPanel === 'price_benefits') {
          const price = root.querySelector('[data-maison-price]');
          if (!price) continue;
          price.insertAdjacentElement('afterend', panel);
        } else {
          const payments = root.querySelector('.maison-pdp__payment-methods');
          const form = root.querySelector('.maison-pdp__form');
          if (payments) payments.before(panel); else if (form) form.after(panel); else continue;
        }
        this._owned.push(panel);
      }
      this._signature = signature;
      if (this._config.singleBlack) {
        const fieldset = root.querySelector('.maison-pdp__variants');
        const radios = fieldset?.querySelectorAll('input[name="maison-variant"]');
        if (radios?.length === 1) {
          const legend = fieldset.querySelector('legend');
          if (legend) legend.textContent = 'Colour: Black';
          fieldset.classList.add('ayeior-single-colour');
        }
      }
      this.updateBadge();
    }
    updateBadge() {
      if (!this._root || !this._config) return;
      const badge = this._root.querySelector('[data-maison-sale-badge]');
      if (!badge) return;
      const id = this._root.querySelector('[data-maison-variant-id]')?.value;
      const variant = this._config.variants.find(item => String(item.id) === String(id));
      if (!variant) return;
      const mode = this._config.badgeMode;
      const price = Number(variant.price), compare = Number(variant.compare);
      const onSale = compare > price && compare > 0;
      if (mode === 'none' || !onSale) {
        badge.classList.add('is-hidden');
        return;
      }
      if (mode === 'offer40') {
        badge.classList.remove('is-hidden');
        badge.textContent = '40% OFF';
        return;
      }
      const percent = Math.floor((compare - price) * 100 / compare + 0.0000001);
      badge.textContent = mode === 'sale' ? 'Sale' : (percent > 0 ? percent + '% OFF' : 'Sale');
    }
  }
  customElements.define('ayeior-purchase-controls', AyeiorPurchaseControls);
})();

